/**
 *  PasswordModal script file
**/

export default {
  name: 'PasswordModal',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      current: null,
      password: null,
      newpassword: null,
      isValid: false
    }
  },
  computed: {
  },
  methods: {
    close () {
      this.$emit('close')
    },
    change () {
      // TODO
    },
    check () {
      this.isValid = this.currentValid() && (this.password === this.newpassword)
    },
    currentValid () {
      // TODO
      return true
    }
  }
}
